export const PRODUCTS_PAGE_SIZE = 5;
export const SEARCH_PAGE_SIZE = 5;
export const PRODUCTS_QUERY_KEY = 'products';
export const SEARCH_QUERY_KEY = 'search_products';
export const ITEMS_QUERY_KEYS = [PRODUCTS_QUERY_KEY, SEARCH_QUERY_KEY];
